import React from "react";
import { Dictionary } from "../../../../entities/common";
import { Icon } from "office-ui-fabric-react";

type Props = {
    item: FlowChartItem;
    getChartItemStyles: GetChartItemStyles;
    onRenderBadge?: (item: FlowChartItem) => React.ReactNode;
    onRenderTrailing?: (item: FlowChartItem) => React.ReactNode;
}

type FlowChartItemStyles = {
    style: React.CSSProperties;
    iconName: string;
}

export const ItemCard = React.forwardRef<HTMLDivElement, Props>(({ item, getChartItemStyles, onRenderBadge, onRenderTrailing }, ref) => {
    const itemInfo = getChartItemStyles(item);
    const trailing = onRenderTrailing?.(item);
    if (trailing) {
        return <div ref={ref} className="flow-chart-item-card-wrapper">
            <div
                className="flow-chart-item-card"
                style={itemInfo.style}
                title={item.attributes.Name}>
                <Icon iconName={itemInfo.iconName} />
                <span className="overflow-text">{item.attributes.Name}</span>
            </div>
            {trailing}
            {onRenderBadge?.(item)}
        </div>;
    }
    return <div
        ref={ref}
        className="flow-chart-item-card"
        style={itemInfo.style}
        title={item.attributes.Name}>
        <Icon iconName={itemInfo.iconName} />
        <span className="overflow-text">{item.attributes.Name}</span>
        {onRenderBadge?.(item)}
    </div>;
})

export type FlowChartItem = { id: string, attributes: { Name?: string } & Dictionary<any> }
export type GetChartItemStyles = (item: FlowChartItem) => FlowChartItemStyles;